function getKRandomNumbersUpToN(k, n) {
    let indices = Array.from({ length: n }, (_, index) => index);
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return indices.slice(0, k);
}

function cleanRawName(rawName) {
    // MAL song names may start with "#N " and end with "(ep N)" or "(eps N)" or "(TV: eps...)".
    // We remove those for the search.
    if (rawName.startsWith('#')) {
        let i = rawName.indexOf(' ');
        rawName = rawName.substring(i + 1);
    }
    if (rawName.includes('ep')) {
        let ep_i = rawName.lastIndexOf('ep');
        let l_paren_i = rawName.lastIndexOf('(');
        let r_paren_i = rawName.lastIndexOf(')');
        if (l_paren_i < ep_i < r_paren_i) {
            rawName = rawName.substring(0, l_paren_i);
        }
    }
    rawName = rawName.trim();
    return rawName.replaceAll("'", '').replaceAll('"', '');
}

function getAnswerChoice(animeSong) {
    return `${animeSong.anime.name} (${animeSong.cleanedName})`;
}

function generatePastelColors(numColors) {
    let baseHue = Math.floor(Math.random() * 360);
    let saturation = 60; // moderate saturation
    let lightness = 85; // high lightness for pastel effect
    let pastelColors = [];
    for (let i = 0; i < numColors; i++) {
        let newHue = (baseHue + (i * Math.floor(360/numColors))) % 360;
        pastelColors.push(`hsl(${newHue},${saturation}%,${lightness}%)`);
    }
    return pastelColors;
}

function darkenHSL(hsl, factor = 0.2) {
    const regex = /^hsl\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*\)$/;
    const match = hsl.match(regex);
    if (!match) {
        throw new Error("Invalid HSL color string");
    }
    let [, h, s, l] = match;
    h = parseInt(h);
    s = parseInt(s);
    l = parseInt(l);
    l = Math.max(0, l - factor * 100);
    return `hsl(${h}, ${s}%, ${l}%)`;
}

function getComplementaryColor(hsl) {
    const regex = /hsl\((\d+),\s*(\d+)%\s*,\s*(\d+)%\)/;
    const match = hsl.match(regex);
    if (!match) {
        throw new Error("Invalid HSL color string format");
    }

    let hue = parseInt(match[1]);
    let saturation = parseInt(match[2]);
    let lightness = parseInt(match[3]);
    return `hsl(${(hue + 180) % 360}, ${saturation}%, ${lightness}%)`;
}

export {
    getKRandomNumbersUpToN,
    cleanRawName,
    getAnswerChoice,
    generatePastelColors,
    getComplementaryColor,
    darkenHSL
}